import type { Client, RequestContext } from "../client";
import type { WorkerToolsLatestImages } from "../resources/index";

export class WorkerToolsRepository {
    constructor(
        private readonly client: Client,
        private readonly requestContext: RequestContext
    ) {}

    getWorkerToolsLatestImages(): Promise<WorkerToolsLatestImages> {
        return this.client.get(this.requestContext, this.client.getLink("WorkerToolsLatestImages"));
    }
}
